import { apiFetch } from './client.js';
import type { Profile } from './use-me.js';

/**
 * POST /api/profile — the account holder's details, once.
 *
 * What the form holds, in the form's own names. camelCase here and snake_case in
 * the response is not an oversight: the request body is the portal's shape and
 * the response is the API's, which speaks the database's language (NM-03).
 * Translating one to match the other would invent a third vocabulary.
 */
export interface ProfileDraft {
  firstName: string;
  lastName: string;
  /** YYYY-MM-DD, which is what an <input type="date"> yields. */
  dateOfBirth: string;
  /** ISO 3166-1 alpha-2. */
  country: string;
}

export interface CompletedProfile extends Profile {
  profile_complete: true;
}

/**
 * Throws ApiError on refusal, carrying the API's code and — for a 422 — the
 * field it is about. The caller decides what to say; this does not turn codes
 * into sentences, because the sentence depends on where it is shown.
 */
export async function submitProfile(
  getToken: () => Promise<string | null>,
  draft: ProfileDraft,
): Promise<CompletedProfile> {
  return apiFetch<CompletedProfile>('/api/profile', getToken, {
    method: 'POST',
    body: JSON.stringify(draft),
  });
}
